import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Legacy route — plan requests live under Plans. */
const PlanRequestsQueue = () => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams({ tab: 'plan-requests' });
  const orgId = searchParams.get('org_id');
  const orgName = searchParams.get('org_name');
  if (orgId) params.set('org_id', orgId);
  if (orgName) params.set('org_name', orgName);
  return <Navigate to={`/plans?${params.toString()}`} replace />;
};

export default PlanRequestsQueue;
